<template>
  <v-app>
    <v-main>
      <v-layout wrap>
        <v-flex xs12>
          <AppHeader v-if="$route.name != 'PageNotFound'" />

          <router-view
            :style="
              $vuetify.breakpoint.name == 'md'
                ? 'padding-top:2px'
                : $vuetify.breakpoint.name == 'xs'
                ? 'padding-top:2px'
                : $vuetify.breakpoint.name == 'sm'
                ? 'padding-top:69px'
                : ''
            "
            style="min-height: 56vh"
            :key="$route.fullPath"
          />
          <appFooter v-if="$route.name != 'PageNotFound'" />
        </v-flex>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
import appFooter from "./components/Common/appFooter";
import AppHeader from "./components/Common/appHeader";
import "./assets/styles/style.css";
import "./assets/styles/font.css";

export default {
  name: "App",

  components: {
    AppHeader,
    appFooter,
  },

  data: () => ({
    //
  }),
};
</script>
